import React from 'react';
import { useStyletron } from 'baseui';
import { Tabs } from '../const';
import { useLabelListData } from '../hooks/use-label-list-data';
import { LabelItem } from './label-item';
type PropsT = {
  filterText?: string;
};
export const LabelList = ({
  filterText
}: PropsT = {}) => {
  const [css] = useStyletron();
  const {
    annotationLabels,
    visibleAnnotationLabels,
    selectedAnnotationLabel,
    annotationCountMap,
    onLabelClick,
    handleOnCountClick,
    handleLabelColorChange,
    labelListItemEnhancer,
    getRenderIcon
  } = useLabelListData({
    annotationsTabKey: Tabs.ANNOTATIONS.key,
    filterText
  });
  return <div className={css({
    maxHeight: '70%',
    overflow: 'auto'
  })}>
      {visibleAnnotationLabels.map(label => {
      const isSelected = label.title === selectedAnnotationLabel?.title;
      const originalIndex = annotationLabels.findIndex(l => l.title === label.title);
      return <LabelItem key={label.title} shortcutKey={originalIndex < 9 ? originalIndex + 1 : undefined} id={label.title} name={label.title} endEnhancer={labelListItemEnhancer?.(label.title)} isSelected={isSelected} annotationCount={annotationCountMap[label.title]} onClick={onLabelClick} onCountClick={handleOnCountClick} handleLabelColorChange={handleLabelColorChange} color={label.style.strokeColor} renderIcon={getRenderIcon(label)} />;
    })}
    </div>;
};